// extracted by mini-css-extract-plugin
export default {"light":"Theme_light__86EzC","dark":"Theme_dark__BnZqw"};